import { render } from "./category-color-bar.vue?vue&type=template&id=98da2c84&scoped=true&ts=true"
import script from "./category-color-bar.vue?vue&type=script&lang=ts"
export * from "./category-color-bar.vue?vue&type=script&lang=ts"

import "./category-color-bar.vue?vue&type=style&index=0&id=98da2c84&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98da2c84"]])

export default __exports__